/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Courier,
  DeliveryFee,
  NewDeliveryFee,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
  Town,
} from '../models/index';
import {
    CourierFromJSON,
    CourierToJSON,
    DeliveryFeeFromJSON,
    DeliveryFeeToJSON,
    NewDeliveryFeeFromJSON,
    NewDeliveryFeeToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
    TownFromJSON,
    TownToJSON,
} from '../models/index';

export interface DeliveryFeeCountRequest {
    where?: string;
}

export interface DeliveryFeeCreateRequest {
    data?: NewDeliveryFee;
}

export interface DeliveryFeeCreateChangeStreamGetDeliveryFeesChangeStreamRequest {
    options?: string;
}

export interface DeliveryFeeCreateChangeStreamPostDeliveryFeesChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface DeliveryFeeDeleteByIdRequest {
    id: string;
}

export interface DeliveryFeeExistsGetDeliveryFeesidExistsRequest {
    id: string;
}

export interface DeliveryFeeExistsHeadDeliveryFeesidRequest {
    id: string;
}

export interface DeliveryFeeFindRequest {
    filter?: string;
}

export interface DeliveryFeeFindByIdRequest {
    id: string;
    filter?: string;
}

export interface DeliveryFeeFindOneRequest {
    filter?: string;
}

export interface DeliveryFeePatchOrCreateRequest {
    data?: DeliveryFee;
}

export interface DeliveryFeePrototypeGetCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface DeliveryFeePrototypeGetTownsRequest {
    id: string;
    refresh?: boolean;
}

export interface DeliveryFeePrototypePatchAttributesRequest {
    id: string;
    data?: DeliveryFee;
}

export interface DeliveryFeeReplaceByIdPostDeliveryFeesidReplaceRequest {
    id: string;
    data?: DeliveryFee;
}

export interface DeliveryFeeReplaceByIdPutDeliveryFeesidRequest {
    id: string;
    data?: DeliveryFee;
}

export interface DeliveryFeeReplaceOrCreatePostDeliveryFeesReplaceOrCreateRequest {
    data?: DeliveryFee;
}

export interface DeliveryFeeReplaceOrCreatePutDeliveryFeesRequest {
    data?: DeliveryFee;
}

export interface DeliveryFeeUpdateAllRequest {
    where?: string;
    data?: DeliveryFee;
}

export interface DeliveryFeeUpsertWithWhereRequest {
    where?: string;
    data?: DeliveryFee;
}

/**
 * 
 */
export class DeliveryFeeApi extends runtime.BaseAPI {

    /**
     * Count instances of the model matched by where from the data source.
     */
    async deliveryFeeCountRaw(requestParameters: DeliveryFeeCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryFees/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async deliveryFeeCount(requestParameters: DeliveryFeeCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.deliveryFeeCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async deliveryFeeCreateRaw(requestParameters: DeliveryFeeCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryFee>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryFees`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewDeliveryFeeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryFeeFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async deliveryFeeCreate(requestParameters: DeliveryFeeCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryFee> {
        const response = await this.deliveryFeeCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async deliveryFeeCreateChangeStreamGetDeliveryFeesChangeStreamRaw(requestParameters: DeliveryFeeCreateChangeStreamGetDeliveryFeesChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['options'] != null) {
            queryParameters['options'] = requestParameters['options'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryFees/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async deliveryFeeCreateChangeStreamGetDeliveryFeesChangeStream(requestParameters: DeliveryFeeCreateChangeStreamGetDeliveryFeesChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.deliveryFeeCreateChangeStreamGetDeliveryFeesChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async deliveryFeeCreateChangeStreamPostDeliveryFeesChangeStreamRaw(requestParameters: DeliveryFeeCreateChangeStreamPostDeliveryFeesChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryFees/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async deliveryFeeCreateChangeStreamPostDeliveryFeesChangeStream(requestParameters: DeliveryFeeCreateChangeStreamPostDeliveryFeesChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.deliveryFeeCreateChangeStreamPostDeliveryFeesChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async deliveryFeeDeleteByIdRaw(requestParameters: DeliveryFeeDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryFeeDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryFees/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async deliveryFeeDeleteById(requestParameters: DeliveryFeeDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.deliveryFeeDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async deliveryFeeExistsGetDeliveryFeesidExistsRaw(requestParameters: DeliveryFeeExistsGetDeliveryFeesidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryFeeExistsGetDeliveryFeesidExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryFees/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async deliveryFeeExistsGetDeliveryFeesidExists(requestParameters: DeliveryFeeExistsGetDeliveryFeesidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.deliveryFeeExistsGetDeliveryFeesidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async deliveryFeeExistsHeadDeliveryFeesidRaw(requestParameters: DeliveryFeeExistsHeadDeliveryFeesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryFeeExistsHeadDeliveryFeesid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryFees/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async deliveryFeeExistsHeadDeliveryFeesid(requestParameters: DeliveryFeeExistsHeadDeliveryFeesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.deliveryFeeExistsHeadDeliveryFeesidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async deliveryFeeFindRaw(requestParameters: DeliveryFeeFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DeliveryFee>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryFees`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DeliveryFeeFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async deliveryFeeFind(requestParameters: DeliveryFeeFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DeliveryFee>> {
        const response = await this.deliveryFeeFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async deliveryFeeFindByIdRaw(requestParameters: DeliveryFeeFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryFee>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryFeeFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryFees/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryFeeFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async deliveryFeeFindById(requestParameters: DeliveryFeeFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryFee> {
        const response = await this.deliveryFeeFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async deliveryFeeFindOneRaw(requestParameters: DeliveryFeeFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryFee>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryFees/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryFeeFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async deliveryFeeFindOne(requestParameters: DeliveryFeeFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryFee> {
        const response = await this.deliveryFeeFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async deliveryFeePatchOrCreateRaw(requestParameters: DeliveryFeePatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryFee>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryFees`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryFeeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryFeeFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async deliveryFeePatchOrCreate(requestParameters: DeliveryFeePatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryFee> {
        const response = await this.deliveryFeePatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async deliveryFeePrototypeGetCourierRaw(requestParameters: DeliveryFeePrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryFeePrototypeGetCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryFees/{id}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async deliveryFeePrototypeGetCourier(requestParameters: DeliveryFeePrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.deliveryFeePrototypeGetCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation towns.
     */
    async deliveryFeePrototypeGetTownsRaw(requestParameters: DeliveryFeePrototypeGetTownsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Town>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryFeePrototypeGetTowns().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryFees/{id}/towns`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TownFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation towns.
     */
    async deliveryFeePrototypeGetTowns(requestParameters: DeliveryFeePrototypeGetTownsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Town> {
        const response = await this.deliveryFeePrototypeGetTownsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async deliveryFeePrototypePatchAttributesRaw(requestParameters: DeliveryFeePrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryFee>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryFeePrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryFees/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryFeeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryFeeFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async deliveryFeePrototypePatchAttributes(requestParameters: DeliveryFeePrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryFee> {
        const response = await this.deliveryFeePrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async deliveryFeeReplaceByIdPostDeliveryFeesidReplaceRaw(requestParameters: DeliveryFeeReplaceByIdPostDeliveryFeesidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryFee>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryFeeReplaceByIdPostDeliveryFeesidReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryFees/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryFeeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryFeeFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async deliveryFeeReplaceByIdPostDeliveryFeesidReplace(requestParameters: DeliveryFeeReplaceByIdPostDeliveryFeesidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryFee> {
        const response = await this.deliveryFeeReplaceByIdPostDeliveryFeesidReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async deliveryFeeReplaceByIdPutDeliveryFeesidRaw(requestParameters: DeliveryFeeReplaceByIdPutDeliveryFeesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryFee>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryFeeReplaceByIdPutDeliveryFeesid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryFees/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryFeeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryFeeFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async deliveryFeeReplaceByIdPutDeliveryFeesid(requestParameters: DeliveryFeeReplaceByIdPutDeliveryFeesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryFee> {
        const response = await this.deliveryFeeReplaceByIdPutDeliveryFeesidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async deliveryFeeReplaceOrCreatePostDeliveryFeesReplaceOrCreateRaw(requestParameters: DeliveryFeeReplaceOrCreatePostDeliveryFeesReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryFee>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryFees/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryFeeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryFeeFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async deliveryFeeReplaceOrCreatePostDeliveryFeesReplaceOrCreate(requestParameters: DeliveryFeeReplaceOrCreatePostDeliveryFeesReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryFee> {
        const response = await this.deliveryFeeReplaceOrCreatePostDeliveryFeesReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async deliveryFeeReplaceOrCreatePutDeliveryFeesRaw(requestParameters: DeliveryFeeReplaceOrCreatePutDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryFee>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryFees`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryFeeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryFeeFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async deliveryFeeReplaceOrCreatePutDeliveryFees(requestParameters: DeliveryFeeReplaceOrCreatePutDeliveryFeesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryFee> {
        const response = await this.deliveryFeeReplaceOrCreatePutDeliveryFeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async deliveryFeeUpdateAllRaw(requestParameters: DeliveryFeeUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryFees/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryFeeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async deliveryFeeUpdateAll(requestParameters: DeliveryFeeUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.deliveryFeeUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async deliveryFeeUpsertWithWhereRaw(requestParameters: DeliveryFeeUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryFee>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryFees/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryFeeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryFeeFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async deliveryFeeUpsertWithWhere(requestParameters: DeliveryFeeUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryFee> {
        const response = await this.deliveryFeeUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
